import { Card } from '../common/card'
import { Button } from '../common/button'

interface StatCardProps {
  icon?: string
  customIcon?: React.ReactNode
  number: string
  title: React.ReactNode
  description?: string
  action?: {
    label: string
    onClick: () => void
  }
  variant?: 'default' | 'highlight' | 'small'
  onIconClick?: () => void
  height?: 'default' | 'tall'
  extraHeight?: boolean
  numberPosition?: 'right' | 'below'
}

export const StatCard: React.FC<StatCardProps> = ({
  icon,
  customIcon,
  number,
  title,
  description,
  action,
  variant = 'default',
  onIconClick = () => console.log(`Clicked on ${title} icon`),
  height = 'default',
  extraHeight = false,
  numberPosition = 'right'
}) => {
  const isSmall = variant === 'small'

  return (
    <Card
      className={`border border-[color:var(--Neutral-200,#E5E5E5)] ${variant === 'highlight' ? 'bg-[#E4F7F4]' : 'bg-white'} flex flex-col w-full h-full ${
        isSmall ? 'p-4' : 'p-6'
      } rounded-xl shadow-sm transition-all duration-200 hover:shadow-md ${height === 'tall' ? 'min-h-64' : extraHeight ? (isSmall ? 'min-h-[90px]' : 'min-h-[183px]') : 'min-h-44'} ${
        isSmall ? 'scale-70 transform origin-top-left' : ''
      }`}
    >
      <div className="w-full flex flex-col h-full">
        {numberPosition === 'right' ? (
          <div className="flex w-full items-center gap-8 mb-5">
            {customIcon ? (
              <div
                onClick={onIconClick}
                className={`cursor-pointer transition-transform hover:scale-105 flex-shrink-0 ${isSmall ? 'scale-90' : ''}`}
              >
                {customIcon}
              </div>
            ) : icon ? (
              <div
                onClick={onIconClick}
                className={`items-center bg-[#F6FAFB] self-stretch flex justify-center ${isSmall ? 'w-10 h-10' : 'w-12 h-12'} rounded-full cursor-pointer transition-transform hover:scale-105 flex-shrink-0`}
              >
                <img
                  src={icon}
                  alt={typeof title === 'string' ? title : 'icon'}
                  className={`aspect-[1] object-contain ${isSmall ? 'w-5' : 'w-6'}`}
                />
              </div>
            ) : null}
            <div className={`text-[#107569] ${isSmall ? 'text-lg' : 'text-xl'} font-bold leading-tight`}>{number}</div>
          </div>
        ) : (
          <div className="flex flex-col items-start mb-5">
            <div className="mb-4">
              {customIcon ? (
                <div
                  onClick={onIconClick}
                  className={`cursor-pointer transition-transform hover:scale-105 ${isSmall ? 'scale-90' : ''}`}
                >
                  {customIcon}
                </div>
              ) : icon ? (
                <div
                  onClick={onIconClick}
                  className={`items-center bg-[#F6FAFB] self-stretch flex justify-center ${isSmall ? 'w-10 h-10' : 'w-12 h-12'} rounded-full cursor-pointer transition-transform hover:scale-105`}
                >
                  <img
                    src={icon}
                    alt={typeof title === 'string' ? title : 'icon'}
                    className={`aspect-[1] object-contain ${isSmall ? 'w-5' : 'w-6'}`}
                  />
                </div>
              ) : null}
            </div>
            <div className={`text-[#107569] ${isSmall ? 'text-lg' : 'text-xl'} font-bold leading-tight`}>{number}</div>
          </div>
        )}
        <div className={`text-[#107569] ${isSmall ? 'text-base' : 'text-[18px]'} font-[600] leading-[24px] mb-6`}>{title}</div>
        {description && (
          <div
            className={`text-[#737373] ${isSmall ? 'text-xs' : 'text-[14px]'} font-[400] leading-[20px] font-['Open_Sans'] ${isSmall ? 'max-w-[200px] min-h-[30px]' : 'max-w-[283px] min-h-[40px]'} mb-4 leading-[150%]`}
          >
            {description}
          </div>
        )}
        {action && (
          <div className="mt-auto pt-3">
            <Button
              onClick={action.onClick}
              variant="secondary"
              size={isSmall ? 'default' : 'lg'}
              className={`bg-[#0E9384] hover:bg-[#0a7d70] text-white font-['Open_Sans'] font-semibold ${isSmall ? 'text-sm' : 'text-[16px]'} leading-[24px] tracking-[0%] rounded-xl px-5 py-3 ${
                isSmall ? 'h-[40px]' : 'h-[48px]'
              } flex items-center justify-center gap-2`}
            >
              {action.label}
            </Button>
          </div>
        )}
      </div>
    </Card>
  )
}
